import { AbstractControl, ValidatorFn } from '@angular/forms';

export function phoneValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        if (control.value === '' || control.value === null) return null;
        const phoneNumberRegex = /^(\+4)?\d{10}$/;
        const valid = phoneNumberRegex.test(control.value);
        return valid ? null : { invalidPhone: { value: control.value } };
    };
}